import { useState, useEffect } from "react";
import CTAButton from "../CTAButton";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#030303]/70 border-b border-white/[0.06] py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 flex items-center justify-between gap-3">
        <div className="font-display font-semibold tracking-[0.16em] sm:tracking-[0.22em] text-xs sm:text-sm uppercase whitespace-nowrap">
          JordyBT<span className="gold-text">_Fitness</span>
        </div>
        <CTAButton testid="navbar-cta" compact />
      </div>
    </header>
  );
}
